import { render, staticRenderFns } from "./AvatarCard.vue?vue&type=template&id=43a0ac7a&"
import script from "./AvatarCard.vue?vue&type=script&lang=js&"
export * from "./AvatarCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports